import { ICandidate } from "../Models";
import { APIURL, Filters, MergeRequest } from "./config";

export const fetchQuarantineCompanies = async (
  token: string,
  pageNumber: number = 1,
  pageSize: number = 15,
  search: string | null = null,
  sortBy: string | null = null,
  sortDesc: boolean = false,
  filters: Filters[] = [],
  univType: undefined | number,
  cityType: undefined | number,
) => {
  const baseUrl = `${APIURL}/Quarantine/QuarantineCompanies`;
  const url = new URL(baseUrl);

  url.searchParams.append("pageNumber", pageNumber.toString());
  url.searchParams.append("pageSize", pageSize.toString());
  if (search) url.searchParams.append("search", search);
  if (sortBy) url.searchParams.append("sortBy", sortBy);
  url.searchParams.append("sortDesc", sortDesc.toString());

  const payload =
    filters?.length > 0
      ? JSON.stringify(filters)
      : JSON.stringify([
        {
          FilterType: "count",
          MinCount: 0,
          MaxCount: 5000,
        },
      ]);

  try {
    const res = await fetch(
      `${url.toString()}&univType=${univType}&cityType=${cityType}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: payload,
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const obj = await res.json();
    return obj;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchQuarantineUniversities = async (
  token: string,
  pageNumber: number = 1,
  pageSize: number = 15,
  search: string | null = null,
  sortBy: string | null = null,
  sortDesc: boolean = false,
  filters: Filters[] = [],
  univType: undefined | number,
  cityType: undefined | number,
) => {
  const baseUrl = `${APIURL}/Quarantine/QuarantineUnis`;
  const url = new URL(baseUrl);

  url.searchParams.append("pageNumber", pageNumber.toString());
  url.searchParams.append("pageSize", pageSize.toString());
  if (search) url.searchParams.append("search", search);
  if (sortBy) url.searchParams.append("sortBy", sortBy);
  url.searchParams.append("sortDesc", sortDesc.toString());

  const payload =
    filters?.length > 0
      ? JSON.stringify(filters)
      : JSON.stringify([
        {
          FilterType: "count",
          MinCount: 0,
          MaxCount: 5000,
        },
      ]);

  try {
    const res = await fetch(
      `${url.toString()}&univType=${univType}&cityType=${cityType}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: payload,
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const obj = await res.json();
    return obj;
  } catch (error) {
    console.error("Error fetching quarantine universities:", error);
    throw error;
  }
};

export const confirmQuarantineUniversity = async (
  token: string,
  id: string,
  universityData: object
) => {
  const url = `${APIURL}/Quarantine/QuarantineUniversity/${id}`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(universityData),
    });
    if (!res.ok) {
      const errorMsg = await res.text();
      throw new Error(`Request failed with status ${res.status}: ${errorMsg}`);
    }
    return "University Updated Successfully.";
  } catch (err) {
    console.error("Error updating university:", err);
  }
};

export const confirmQuarantineCompany = async (
  token: string,
  id: string,
  companyData: object
) => {
  const url = `${APIURL}/Quarantine/QuarantineCompany/${id}`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(companyData),
    });
    if (!res.ok) {
      const errorMsg = await res.text();
      throw new Error(`Request failed with status ${res.status}: ${errorMsg}`);
    }
    return "Company Updated Successfully.";
  } catch (err) {
    console.error("Error updating Company:", err);
  }
};

export const deleteQuarantineUniversity = async (
  token: string,
  oldId: string,
  newId: string
) => {
  try {
    const QuarantineUniversityId = oldId;
    const ConfirmedUniversityId = newId;
    const response = await fetch(
      `${APIURL}/Quarantine/QuarantineUniversity/${QuarantineUniversityId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(ConfirmedUniversityId),
      }
    );

    if (response.ok) {
      const data = await response.text();
      return data;
    } else {
      throw new Error("Failed to delete university");
    }
  } catch (error) {
    console.error("Error:", error);
  }
};

export const deleteQuarantineCompany = async (
  token: string,
  oldId: string,
  newId: string
) => {
  try {
    const QuarantineCompanyId = oldId;
    const ConfirmedCompanyId = newId;
    const response = await fetch(
      `${APIURL}/Quarantine/QuarantineCompany/${QuarantineCompanyId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(ConfirmedCompanyId),
      }
    );

    if (response.ok) {
      const data = await response.text();
      return data;
    } else {
      throw new Error("Failed to delete Company");
    }
  } catch (error) {
    console.error("Error:", error);
  }
};

export const fetchActionsLog = async (token: string) => {
  const res = await fetch(`${APIURL}/Quarantine/ActionsLog`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await res.json();
  return data;
};

export const revertConfirm = async (actionId: string, token: string) => {
  try {
    const response = await fetch(
      `${APIURL}/Quarantine/ActionsLog/RevertConfirm`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(actionId),
      }
    );
    if (response.ok) {
      const data = await response.text();
      return data;
    } else {
      throw new Error("Failed to Revert Action.");
    }
  } catch (error) {
    console.error("Error:", error);
  }
};

export const revertReject = async (actionId: string, token: string) => {
  try {
    const response = await fetch(
      `${APIURL}/Quarantine/ActionsLog/RevertReject`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(actionId),
      }
    );
    if (response.ok) {
      const data = await response.text();
      return data;
    } else {
      throw new Error("Failed to Revert Action.");
    }
  } catch (error) {
    console.error("Error:", error);
  }
};

export const fetchCompanyLocations = async (companyName: string | undefined, token: string) => {
  const response = await fetch(
    `${APIURL}/Quarantine/CompanyLocations?${companyName ? `companyName=${companyName}&` : ""}pageNumber=${1}&pageSize=${500}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  try {
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      throw new Error("Failed to Fetch CompanyLocations.");
    }
  } catch (error) {
    console.error("Error:", error);
  }
};

export const getCandidatesByCompanyUrl = async (url: string, token: string) => {
  try {
    const res = await fetch(`${APIURL}/Quarantine/GetCandidateByCompanyUrl`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(url),
    });

    if (!res.ok) {
      throw new Error(`Error: ${res.statusText}`);
    }

    const candidates: ICandidate[] = await res.json();
    return candidates;
  } catch (error) {
    console.error("Error fetching candidates by company URL:", error);
    return [];
  }
};

export const getCandidatesByUniversityUrl = async (url: string, token: string) => {
  try {
    const res = await fetch(
      `${APIURL}/Quarantine/GetCandidateByUniversityUrl`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(url),
      }
    );

    if (!res.ok) {
      throw new Error(`Error: ${res.statusText}`);
    }

    const candidates: ICandidate[] = await res.json();
    return candidates;
  } catch (error) {
    console.error("Error fetching candidates by university URL:", error);
    return [];
  }
};

export const validateUniversityUrl = async (url: string, token: string): Promise<{ isReachable: boolean; statusCode: number; message: string }> => {
  const res = await fetch(`${APIURL}/Quarantine/ValidateUrl`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(url),
  });
  if (!res.ok) throw new Error(`Error: ${res.statusText}`);
  return res.json();
};

export const getUnconfirmedCities = async (
  selectedStates: string[],
  query: string,
  sortBy: string | null = null,
  sortDesc: boolean = false,
  pageNumber: number = 1,
  pageSize: number = 40,
  showConfirmed: boolean,
  token: string
) => {
  const res = await fetch(`${APIURL}/Quarantine/UnconfirmedCities`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      selectedStates,
      searchQuery: query,
      sortBy,
      sortDesc,
      pageNumber,
      pageSize,
      showConfirmed,
    }),
  });

  if (!res.ok) {
    throw new Error("Failed to fetch unconfirmed cities");
  }

  return res.json();
};

export const getSimilarCityGroupsWithSuggestions = async (
  similarityThreshold: number = 0.88,
  pageNumber: number = 1,
  pageSize: number = 500,
  token: string
) => {
  // This endpoint uses GET, so parameters are added to the URL.
  const params = new URLSearchParams({
    similarityThreshold: similarityThreshold.toString(),
    pageNumber: pageNumber.toString(),
    pageSize: pageSize.toString(),
  });

  const url = `${APIURL}/Quarantine/GetCityGroupsWithSuggestions?${params.toString()}`;

  const res = await fetch(url, {
    method: "GET", // This is a GET request
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    throw new Error("Failed to fetch similar city groups");
  }

  return res.json();
};

export const mergeDuplicateCities = async (mergeGroups: MergeRequest[], token: string) => {
  const url = `${APIURL}/Quarantine/MergeDuplicateCities`;

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(mergeGroups),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to merge duplicates: ${errorText}`);
  }

  return res.json();
};


export const updateCityState = async (
  cityId: string,
  newStateName: string,
  token: string
) => {
  const response = await fetch(`${APIURL}/Quarantine/UpdateCityState`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ cityId, newStateName }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to update city state");
  }

  return await response.json();
};

export const rejectAndReplaceCities = async (
  rejectedData: { cityId: string; replacedCityId: string | null }[],
  token: string
) => {
  const response = await fetch(`${APIURL}/Quarantine/RejectAndReplaceCity`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(rejectedData),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to reject and replace cities");
  }

  return await response.json();
};

export const updateQuarantineCity = async (updatedRows: any, token: string) => {
  const response = await fetch(`${APIURL}/Quarantine/UpdateQuarantineCities`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(updatedRows),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to update cities");
  }

  return await response.text();
};

export interface FixUniversityNamesRequest {
  correctName: string;
  universityIds: string[];
}

export const getSimilarUniversityGroups = async (
  similarityThreshold: number = 0.80,
  pageNumber: number = 1,
  pageSize: number = 500,
  token: string
) => {
  const params = new URLSearchParams({
    similarityThreshold: similarityThreshold.toString(),
    pageNumber: pageNumber.toString(),
    pageSize: pageSize.toString(),
  });

  const url = `${APIURL}/Quarantine/GetSimilarUniversityGroups?${params.toString()}`;

  const res = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    throw new Error("Failed to fetch similar university groups");
  }

  return res.json();
};

export const refreshSimilarUniversityGroupsCache = async (token: string) => {
  const res = await fetch(`${APIURL}/Quarantine/RefreshSimilarUniversityGroupsCache`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) throw new Error("Failed to refresh cache");
  return res.json();
};

export const fixUniversityNames = async (
  fixRequests: FixUniversityNamesRequest[],
  token: string
) => {
  const url = `${APIURL}/Quarantine/FixUniversityNames`;

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(fixRequests),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to fix university names: ${errorText}`);
  }

  return res.json();
};

// ===== Similar Company Groups =====

export interface FixCompanyNamesRequest {
  correctName: string;
  companyIds: string[];
}

export const getSimilarCompanyGroups = async (
  similarityThreshold: number = 0.90,
  pageNumber: number = 1,
  pageSize: number = 10,
  token: string
) => {
  const params = new URLSearchParams({
    similarityThreshold: similarityThreshold.toString(),
    pageNumber: pageNumber.toString(),
    pageSize: pageSize.toString(),
  });

  const url = `${APIURL}/Quarantine/GetSimilarCompanyGroups?${params.toString()}`;

  const res = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    throw new Error("Failed to fetch similar company groups");
  }

  return res.json();
};

export const refreshSimilarCompanyGroupsCache = async (token: string) => {
  const res = await fetch(`${APIURL}/Quarantine/RefreshSimilarCompanyGroupsCache`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) throw new Error("Failed to refresh cache");
  return res.json();
};

export const fixCompanyNames = async (
  fixRequests: FixCompanyNamesRequest[],
  token: string
) => {
  const url = `${APIURL}/Quarantine/FixCompanyNames`;

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(fixRequests),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to fix company names: ${errorText}`);
  }

  return res.json();
};

export const suggestUniversityName = async (
  names: string[],
  cities: string[][],
  urls: string[][],
  token: string
): Promise<string> => {
  const res = await fetch(`${APIURL}/Quarantine/SuggestUniversityName`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ names, cities, urls }),
  });

  if (!res.ok) throw new Error("Failed to get AI suggestion");
  const data = await res.json();
  return data.suggestedName;
};

export const suggestCompanyName = async (
  names: string[],
  urls: string[][],
  locations: string[][],
  token: string
): Promise<string> => {
  const res = await fetch(`${APIURL}/Quarantine/SuggestCompanyName`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ names, urls, locations }),
  });

  if (!res.ok) throw new Error("Failed to get AI suggestion");
  const data = await res.json();
  return data.suggestedName;
};

export const suggestCompanyInfo = async (
  names: string[],
  urls: string[][],
  linkedIns: string[][],
  locations: string[][],
  token: string
): Promise<{ websiteUrl: string; linkedInUrl: string }> => {
  const res = await fetch(`${APIURL}/Quarantine/SuggestCompanyInfo`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ names, urls, linkedIns, locations }),
  });
  if (!res.ok) throw new Error("Failed to get AI company info suggestion");
  return res.json();
};

export interface ConsolidateCompanyGroupRequest {
  correctName: string;
  correctUrl: string;
  correctLinkedIn?: string;
  companyIds: string[];
}

export const consolidateCompanyGroup = async (
  request: ConsolidateCompanyGroupRequest,
  token: string
): Promise<{ message: string; newCompanyId: string }> => {
  const res = await fetch(`${APIURL}/Quarantine/ConsolidateCompanyGroup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(request),
  });
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to consolidate company group: ${errorText}`);
  }
  return res.json();
};

export interface ConsolidatePartitionRequest {
  winnerCompanyId: string;
  loserCompanyIds: string[];
  selectedCityIds: string[];
  confirmedUrl?: string;
}

export const consolidatePartition = async (
  request: ConsolidatePartitionRequest,
  token: string
): Promise<{ message: string; winnerId: string }> => {
  const res = await fetch(`${APIURL}/Quarantine/ConsolidatePartition`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(request),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to consolidate partition: ${errorText}`);
  }

  return res.json();
};

// Get AI suggestions for alternate city names
export const getAlternateNameSuggestions = async (
  cityName: string,
  stateName: string,
  token: string
): Promise<{ alternateNames: string[] }> => {
  const response = await fetch(`${APIURL}/AI/GetAlternateNames`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      cityName,
      stateName,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to get alternate name suggestions");
  }

  return response.json();
};
